<div class="dashboard-module-item-routing" fxLayout="column" fxLayoutAlign="start center" fxFlexFill>
  <mat-card class="dashboard-module-item-routing__info-card" *ngIf="!canRouteList.length || jumpToList.length <= 1">
    <mat-card-header>
      <mat-card-title class="dashboard-module-item-routing__info-card-title"> Unable to add routing </mat-card-title>
    </mat-card-header>
    <mat-card-content class="dashboard-module-item-routing__info-card-content">
      <div *ngIf="!canRouteList.length">
        It is not possible to add a routing to this module item because this item (and its predecessors) are no
        questions.
      </div>
      <div *ngIf="jumpToList.length <= 1">
        It is not possible to add a routing to this module item because there is no, or only one item after this module
        to route to.
      </div>
    </mat-card-content>
  </mat-card>
  <div *ngIf="canRouteList.length && jumpToList.length > 1" fxLayout="row" fxFlexFill>
    <div
      class="dashboard-module-item-routing__enable-routing"
      *ngIf="!this.routing?.routingGroups?.length"
      fxLayout="column"
      fxLayoutAlign="center center"
      fxFlexFill
    >
      There are no routing rules defined for this module item.
      <div class="dashboard-module-item-routing__enable-routing-button-holder">
        <button mat-button mat-raised-button color="accent" (click)="addRoutingGroup()">
          {{ 'Enable routing' | uppercase }}
        </button>
      </div>
    </div>
    <div
      class="dashboard-module-item-routing__routing-groups"
      *ngIf="routing"
      fxLayout="column"
      fxFlex="100"
      fxLayoutGap="30px"
    >
      <mat-card
        class="dashboard-module-item-routing__routing-groups-routing-group"
        *ngFor="let group of routing.routingGroups; let groupIndex = index"
        fxLayout="row"
      >
        <mat-card-content fxLayout="column" fxFlex="100" fxLayoutGap="30px">
          <a
            class="dashboard-module-item-routing__routing-groups-routing-group-remove"
            (click)="removeRoutingGroup(groupIndex)"
          >
            <mat-icon>close</mat-icon>
          </a>
          <div class="dashboard-module-item-routing__routing-groups-routing-group-title" fxLayout="row">
            <strong>Route {{ groupIndex + 1 }}</strong>
          </div>
          <div
            class="dashboard-module-item-routing__routing-groups-routing-group-expression"
            *ngFor="let expression of group.expressions; let expressionIndex = index"
            fxLayout="row"
          >
            <div fxLayout="column" fxFlex="100" fxLayoutGap="30px">
              <div fxLayout="row" fxLayoutGap="20px">
                <div fxLayout="column" fxFlex="20">
                  <strong *ngIf="!expressionIndex">If</strong>
                  <mat-form-field appearance="fill" *ngIf="expressionIndex === 1">
                    <mat-select [(ngModel)]="group.operator">
                      <mat-option value="&&">AND</mat-option>
                      <mat-option value="||">OR</mat-option>
                    </mat-select>
                  </mat-form-field>
                  <span *ngIf="expressionIndex > 1">{{ group.operator }}</span>
                </div>
                <div fxLayout="column" fxFlex="65">
                  <mat-form-field appearance="fill">
                    <mat-select
                      [(ngModel)]="expression.moduleItemId"
                      (ngModelChange)="initExpressionOptions(expression)"
                    >
                      <mat-option *ngFor="let canRouteItem of canRouteList" [value]="canRouteItem?.id">
                        {{ canRouteItem?.sortOrder + 1 }}. {{ canRouteItem?.question | dashboardStripHtml }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxLayout="column" fxLayoutAlign="center end" fxFlex="15">
                  <div fxLayout="row">
                    <a
                      class="dashboard-module-item-routing__routing-groups-routing-group-expression-action-icon"
                      *ngIf="group.expressions.length > 1"
                      (click)="removeExpression(group, expressionIndex)"
                    >
                      <mat-icon>delete</mat-icon>
                    </a>
                    <a
                      class="dashboard-module-item-routing__routing-groups-routing-group-expression-action-iconadd"
                      (click)="addExpression(group, expressionIndex)"
                    >
                      <mat-icon>add</mat-icon>
                    </a>
                  </div>
                </div>
              </div>
              <div fxLayout="row" fxLayoutGap="20px">
                <div fxLayout="column" fxFlex="20"></div>
                <div fxLayout="column" fxFlex="40">
                  <mat-form-field
                    appearance="fill"
                    *ngIf="expression.moduleItemId && expressionOptions[expression.moduleItemId]"
                  >
                    <mat-select [(ngModel)]="expression.operator">
                      <mat-option
                        [value]="expressionOptionsOperator.operator"
                        *ngFor="let expressionOptionsOperator of expressionOptions[expression.moduleItemId].operators"
                      >
                        {{ expressionOptionsOperator.label }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                </div>
                <div fxLayout="column" fxFlex="40">
                  <mat-form-field
                    appearance="fill"
                    *ngIf="expression.moduleItemId && expressionOptions[expression.moduleItemId].answerOptions.length"
                  >
                    <mat-select [(ngModel)]="expression.answer">
                      <mat-option
                        [value]="
                          expressionOptions[expression.moduleItemId].itemType === ModuleItemAvailableType.NUMBER
                            ? expressionOptionsAnswer.toString()
                            : expressionOptionsAnswerIndex.toString()
                        "
                        *ngFor="
                          let expressionOptionsAnswer of expressionOptions[expression.moduleItemId].answerOptions;
                          let expressionOptionsAnswerIndex = index
                        "
                      >
                        {{ expressionOptionsAnswer }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                  <mat-form-field
                    appearance="fill"
                    *ngIf="expression.moduleItemId && !expressionOptions[expression.moduleItemId].answerOptions.length"
                  >
                    <input matInput placeholder="Your answer here..." required [(ngModel)]="expression.answer" />
                  </mat-form-field>
                </div>
              </div>
              <div
                fxLayout="row"
                class="dashboard-module-item-routing__routing-groups-routing-group-expression-divider"
              >
                <mat-divider></mat-divider>
              </div>
            </div>
          </div>
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxLayout="column" fxFlex="20">
              <strong>Jump to</strong>
            </div>
            <div fxLayout="column" fxFlex="80">
              <mat-form-field appearance="fill">
                <mat-select [(ngModel)]="group.routeToId">
                  <mat-option [value]="jumpToListItem?.id" *ngFor="let jumpToListItem of jumpToList">
                    {{ jumpToListItem?.sortOrder >= 0 ? jumpToListItem?.sortOrder + 1 + '.' : '' }}
                    {{ jumpToListItem?.question | dashboardStripHtml }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div
        class="dashboard-module-item-routing__routing-groups-add"
        fxLayout="row"
        fxLayoutAlign="end center"
        *ngIf="routing.routingGroups.length"
      >
        <button mat-button color="primary" (click)="addRoutingGroup()">
          {{ 'Add route' | uppercase }}
        </button>
      </div>
      <mat-card
        class="dashboard-module-item-routing__routing-groups-otherwise"
        fxLayout="row"
        *ngIf="routing.routingGroups.length"
      >
        <mat-card-content fxLayout="column" fxFlex="100">
          <div fxLayout="row" fxLayoutGap="20px">
            <div fxLayout="column" fxFlex="20">
              <strong>Otherwise, jump to</strong>
            </div>
            <div fxLayout="column" fxFlex="80">
              <mat-form-field appearance="fill">
                <mat-select [(ngModel)]="routing.otherwiseRouteToId">
                  <mat-option [value]="jumpToListItem?.id" *ngFor="let jumpToListItem of jumpToList">
                    {{ jumpToListItem?.sortOrder >= 0 ? jumpToListItem?.sortOrder + 1 + '.' : '' }}
                    {{ jumpToListItem?.question | dashboardStripHtml }}
                  </mat-option>
                </mat-select>
              </mat-form-field>
            </div>
          </div>
        </mat-card-content>
      </mat-card>
      <div fxLayout="row" fxLayoutAlign="end center" *ngIf="routing.routingGroups.length">
        <button mat-button mat-raised-button color="accent" (click)="saveRouting()">
          {{ 'Save Routing' | uppercase }}
        </button>
      </div>
    </div>
  </div>
</div>
